/* Method for getting and updating list data */

import axios from 'axios'
import errorParser from '@/shared/utils/ErrorParser'

export default {
    
    /**
     * Send email
     * @param {string} template name
     * @param {string} cluster 
     * @param {string} uuid 
     */
    send(template, cluster, uuid) {
        return new Promise((resolve, reject) => {
            axios.get('/email/'+cluster+"/"+template+"/"+uuid).then(({data}) => {
                resolve(data);
            }).catch((error) => {
                reject(errorParser.parse(error));
            });
        });
    }

}
